module.exports = __webpack_public_path__ + "static/media/registar_desconto.39d7c2cd.svg";